import { useState, useEffect } from 'react';
import { IonContent, IonPage, IonModal, IonToast } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { base64FromPath } from '@ionic/react-hooks/filesystem';
import { config } from '../Constants';
import CryptoJS from 'crypto-js';
import { Camera } from '@capacitor/camera';
import React from 'react';

import trailerFront from '../imgs/tarp_photo/trailerFront.jpg';
import trailerRear from '../imgs/tarp_photo/trailerRear.jpg';
import trailerSide from '../imgs/tarp_photo/trailerSide.jpg';
import { ApiService } from '../api/ApiService';
import { ChevronRight, CameraIcon, TrashIcon } from '../components/icons';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { useLogPageVisit } from '../utils/logPageVisit';
import { logUserAction } from '../utils/logUserAction';
import TarpPayFirstIn from '../components/walkthrough/individualPage/TarpPayFirstIn';

const timages: any[] = [];

interface Photo {
  filepath: string;
  webviewPath?: string;
  data: any;
}

let hashArray: any = [];

const EXAMPLES = [
  {
    key: 'rear',
    label: (
      <>
        <b>Rear</b> view with trailer # included
      </>
    ),
    src: trailerRear,
    alt: 'Rear trailer example',
  },
  {
    key: 'side',
    label: (
      <>
        <b>Side</b> view of the tarped load
      </>
    ),
    src: trailerSide,
    alt: 'Side trailer example',
  },
  {
    key: 'front',
    label: (
      <>
        <b>Front</b> view of the tarped load
      </>
    ),
    src: trailerFront,
    alt: 'Front trailer example',
  },
] as const;

const PhotoUpload: React.FC<{ moduleHistory: string }> = () => {
  useLogPageVisit('LP Tarp Photos', 'User viewed the Tarp Photos page');
  const history = useHistory();
  const { onSheet, onIonScroll } = useTransparentHeaderContrast();

  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showErrorModal2, setShowErrorModal2] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successPhoto, setSuccess] = useState(false);
  const [toast, setToast] = useState<string>("")
  const [images, setImages] = useState<Photo[]>([]);
  const [userLat, setUserLat] = useState<number>(36.1627);
  const [userLong, setUserLong] = useState<number>(-86.7816);
  const [loadNumber, setLoadNumber] = useState<string>("");
  const [dispatchNumber, setDispatchNumber] = useState<string>("");
  const [unitNumber, setUnitNumber] = useState("");
  const [dmEmail, setDmEmail] = useState<string>("");
  const [submitDisabled, setSubmitDisabled] = useState(false)
  const [trailerNumber, setTrailerNumber] = useState("");
  const [dmCode, setDmCode] = useState("");
  const [division, setDivision] = useState("");
  const [openExample, setOpenExample] = useState<string | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setTimeout(() => setMounted(true), 30);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    // get unit number from userProfile
    var data = new FormData()
    data.append("payload", JSON.stringify({ cmds: [{cmd: "driverProfile", args: {ownerCode: localStorage.getItem('username')?.toUpperCase(), loginToken: localStorage.getItem('token')}}] }))
    const requestOptions = {
      method: 'POST',
      headers: {},
      body: data
    };
    //console.log(requestOptions)
    fetch(config.url.BASE_URL, requestOptions)
      .then(response => response.json())
      .then(json => {
        if (json.results[0].errcode === 'NOTLOGGEDIN') {localStorage.removeItem('token')}
        else if (json.results[0].errmsg) {

          console.error("Error: ", json.results[0].errmsg);
        }
          else {
            setDmCode(json.results[0].dmCode)
            setDmEmail(json.results[0].dmEmail)
            setTrailerNumber(json.results[0].trailer)
            setUnitNumber(json.results[0].unit)
            getLoadNumber(json.results[0].unit)
            setDivision(json.results[0].division)
          }
      })
          // get load number from loadCurrent
  }, [])

  enum CameraResultType {
    Uri = 'uri',
    Base64 = 'base64',
    DataUrl = 'dataUrl'
  }

  function getLoadNumber(unitNumber: string) {
    var data = new FormData()
    data.append("payload", JSON.stringify({ cmds: [{cmd: "loadDetails", args: {unit: unitNumber, username: localStorage.getItem('username')?.toUpperCase(), loginToken: localStorage.getItem('token')}}] }))
    const requestOptions = {
      method: 'POST',
      headers: {},
      body: data
    };
    fetch(config.url.BASE_URL, requestOptions)
    .then(response => response.json())
    .then(json => {if (json.results[0].errcode === 'NOTLOGGEDIN') {localStorage.removeItem('token')} else if (json.results[0].errcode === "SYSERR") {} else if (json.results[0].load) { setLoadNumber(json.results[0].load.loadNumber); setDispatchNumber(json.results[0].load.dispatchNumber); console.log("load Number", json.results[0].load.loadNumber);} })
  }

  const b64toBlob = (base64:any) =>
  fetch(base64).then(res => res.blob())

  function sendDmMessage() {
    const toList = "kshinkle@westernexp.com";
    const emailBody = 'Driver ' + dmCode + " has submitted a tarp photo. To view this photo, go to: http://software.westernexp.com/admin-console/tarppay and enter the driver code." ;
    var data = new FormData()
    data.append("payload", JSON.stringify({ cmds: [{cmd: 'genericEmail', args: {to: toList, subject: 'Tarp Photo Submitted', body: emailBody, loginToken: localStorage.getItem('token')}}]}))
    const requestOptions = {
      method: 'POST',
      headers: {},
      body: data
    };
    fetch(config.url.BASE_URL, requestOptions)
    .then(response => response.json())
    .then(json => {if(json.results[0].errmsg){setToast((json.results[0].errcode + ": " + json.results[0].errmsg)); ; setShowToast(true)}})
    .catch(() => {})
    .finally(() => redirectPage());
  }

  async function submitReport() {
    setSubmitDisabled(true);
    if (images.length < 3) {
      setToast("Please ensure you have the required number of photos for a submission (3)")
      setShowToast(true);
      setSubmitDisabled(false);
      return;
    }
    await getUserLongLat();
    setLoading(true);
    let ln = loadNumber;
    if (!ln) { setToast("No active load found"); setShowToast(true); setLoading(false); setSubmitDisabled(false); return; }
    try {
      var data = new FormData()
      data.append("payload", JSON.stringify({ cmds: [{cmd: "genericReportSubmission", args: {driverCode: localStorage.getItem('username')?.toUpperCase(), loginToken: localStorage.getItem('token'), load: ln, trailer: trailerNumber, unit: unitNumber, comment: 'Empty'}}] }))
      const requestOptions = {
        method: 'POST',
        headers: {},
        body: data
      };
      const response = await fetch(config.url.BASE_URL, requestOptions);
      const json = await response.json();
      if (json.results[0].load) { setLoadNumber(json.results[0].load.loadNumber) }
      const refId = json.results[0].genericReportId;
      await submitPhotos(refId, ln);
    } catch (err) {
      setLoading(false);
      setSubmitDisabled(false);
      setToast("Your submission could not be sent. Please check your connection and try again.");
      setShowToast(true);
    }
  }

    async function submitPhotos(refId: any, ln: any) {
      // Submit pictures --
      var data = new FormData()
      data.append("payload", JSON.stringify({ cmds: [{cmd: "photoSubmission", args: {driverCode: localStorage.getItem('username')?.toUpperCase(), loginToken: localStorage.getItem('token'), refId: refId, load: ln, division: division, trailer: trailerNumber, unit: unitNumber, type: "tarp", dmCode: dmCode, dispatchNumber: dispatchNumber, uploaderType: "app"}}] }))
      const requestOptions = {
        method: 'POST',
        headers: {},
        body: data
      };
      await fetch(config.url.BASE_URL, requestOptions);
      await uploadPhotos(refId);
    }

    async function uploadPhotos(refId: any) {
      logUserAction('LP Tarp Upload', 'User submitted tarp photos');
      var data = new FormData();
      data.append("payload", JSON.stringify({ cmds: [{cmd: "photoUpload", args: {loginToken: localStorage.getItem('token'), refId: refId, type: "tarp", dmCode: dmCode}}] }))
      for (let i = 0; i < images.length; i++) {
        data.append(`photos${i}`, new Blob([(await b64toBlob(images[i].data))],{type: 'application/octet-stream'}));
      }
      const requestOptions = {
        method: 'POST',
        body: data
      };
      const response = await fetch(config.url.BASE_URL, requestOptions);
      const json = await response.json();
      if (json.results[0].errmsg) {
        setShowErrorModal(true);
        removeHashes(hashArray);
        setLoading(false);
        setSubmitDisabled(false);
      } else {
        setLoading(false);
        setSuccess(true);
        sendDmMessage();
      }
    }

    const redirectPage = () => {
      setTimeout(function() {
        window.location.replace('./Home');
      }, 3000)
    }

    async function takePicture() {
      const image = await Camera.getPhoto({
        quality: 30,
        allowEditing: false,
        resultType: CameraResultType.Uri
      });
      const fileName = new Date().getTime() + '.jpeg';
      // await addDateTime(image.webPath!)
      const base64Data = await base64FromPath(image.webPath!);
      if (await checkHash(base64Data)) {
        console.log("data");
        const newPhotos = [{
          filepath: fileName,
          webviewPath: image.webPath,
          data: base64Data
        }, ...images];
        setImages(newPhotos)
        timages.push(image)
        getUserLongLat();
        console.log("hashArray", hashArray);
      }
    }

    async function checkHash(base64Data: string) {
      var hash = CryptoJS.MD5(base64Data).toString();
      let result = false;
      await ApiService.photoChecksum("tarpPhotos", {checksum: hash}).then(it => {
        hashArray.push(hash)
        result = true;
      })
      .catch(function(err) {
        setShowErrorModal2(true);
        result = false
      })
      return result;
    }

    const removePhoto = (e: any) => {
      console.log("hashArasyaya", hashArray);
      const name = e.filepath;
      var hash = CryptoJS.MD5(e.data).toString();
      console.log("test remove", hash, hashArray);
      hashArray.forEach(async (element: any) => {
        console.log("hashArray removal", hash, element);
        if (hash === element) {
          await removeHashes([element])
          hashArray = hashArray.filter((hash: any) => hash !== element)
        }
      });
      setImages(images.filter(image => image.filepath !== name));
    }

    async function removeHashes(removalArray: any) {
      removalArray.forEach(async (element: any) => {
        await ApiService.photoChecksumRevoke("tarpPhotos", {checksum: element}).then(it => {
          hashArray = hashArray.filter((hash: any) => hash !== element)
        })
      });
    }

    async function getUserLongLat() {
      navigator.geolocation.getCurrentPosition(success, error)
    }

    async function success(pos: {coords: any; }) {
      setUserLat(await pos.coords.latitude);
      setUserLong(await pos.coords.longitude);
    }

    function error(err: any) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/Trip');
    };

    const photoCountLabel =
      images.length === 0
        ? '0 of 3 photos'
        : `${images.length} of 3 photo${images.length === 1 ? '' : 's'}`;

    void showLoadingModal;
    void userLat;
    void userLong;
    void dmEmail;

  return (
    <IonPage>
      <LoadDetailHeader title="Tarp Photos" onBack={goBack} onSheet={onSheet} />

      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={toast}
        color="danger"
        duration={5000}
      />
       <IonModal isOpen={loading} id="transparent">
        <div className="modal-div">
          <div id="modal">
            <div className='loading-div'>
              <p>Please wait... your photos are being submitted.</p>
              <div className="snippet" data-title=".dot-flashing" style={{ margin: "4px 16px"}}>
                <div className="stage">
                  <div className="dot-flashing"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonModal>
      <IonModal isOpen={showErrorModal2} id="transparent">
        <div className="modal-div">
          <div id="modal">
            <div className='warning-div' style={{backgroundColor: "#e9e9e9 !important", color: "#fff !important"}}>
              <h3 style={{textAlign: "center", fontWeight: "600"}}>Error!</h3>
              <p>This photo has already been submitted. Please select a new photo that has not been previously submitted.</p>
              <div className="snippet" data-title=".dot-flashing" style={{ margin: "4px 16px"}}>
                <div className="stage">
                  <button type="button" className="profile-submit" onClick={() => setShowErrorModal2(false)}>I Understand</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonModal>
      <IonToast
        isOpen={successPhoto}
        onDidDismiss={() => {setLoading(false); setSuccess(false)}}
        message="Your photos were submitted."
        color="success"
        duration={3000}
      />
       <IonToast
        isOpen={showErrorModal}
        message="Error! One or more photos could not be uploaded, check your connection and please try again."
        color="danger"
        duration={5000}
      />

      <IonContent
        fullscreen
        className="design-a-content design-a-content--light"
        scrollEvents={true}
        onIonScroll={onIonScroll}
      >
        <TarpPayFirstIn>
          <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
            <div className="home-hero photo-hero">
              <div className="photo-hero__eyebrow">Trip documentation</div>
              <div className="photo-hero__title home-display">Tarp Photos</div>
              <div className="photo-hero__meta">{photoCountLabel} · rear, side &amp; front required</div>
            </div>

            <div className="home-sheet photo-sheet">
              <div className="photo-card">
                <div className="photo-card__title">Required views</div>
                <p className="photo-card__body">
                  Submit three photos of the tarped load. Tap an example to see the angle we need.
                </p>
                <div id="rearSideFrontSection" className="photo-examples">
                  {EXAMPLES.map(example => {
                    const isOpen = openExample === example.key;
                    return (
                      <div key={example.key} className={`photo-example${isOpen ? ' is-open' : ''}`}>
                        <button
                          type="button"
                          className="photo-example__header"
                          onClick={() => setOpenExample(isOpen ? null : example.key)}
                          aria-expanded={isOpen}
                        >
                          <span className="photo-example__label">{example.label}</span>
                          <span
                            className={`photo-example__chevron${isOpen ? ' is-open' : ''}`}
                            aria-hidden="true"
                          >
                            <ChevronRight color="oklch(0.55 0.01 260)" />
                          </span>
                        </button>
                        <div className="photo-example__preview">
                          <img src={example.src} alt={example.alt} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="photo-card">
                <div className="photo-card__title">Your photos</div>
                {images.length === 0 ? (
                  <p className="photo-empty">No photos yet. Take rear, side, and front views.</p>
                ) : (
                  <div className="photo-grid">
                    {images.map((img, index) => (
                      <button
                        key={img.filepath || index}
                        type="button"
                        className="photo-thumb"
                        onClick={() => removePhoto(img)}
                        aria-label="Remove photo"
                      >
                        <img alt="Tarp photo" src={img.webviewPath} />
                        <span className="photo-thumb__remove">
                          <TrashIcon size={14} />
                        </span>
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div id="TarpPayBottom" className="photo-actions">
                <button type="button" className="photo-capture" onClick={() => takePicture()}>
                  <CameraIcon size={20} />
                  <span>{images.length > 0 ? 'Take another photo' : 'Take photo'}</span>
                </button>
                <button
                  type="button"
                  className="profile-submit"
                  disabled={submitDisabled}
                  onClick={() => submitReport()}
                >
                  Submit for tarp pay
                </button>
              </div>
            </div>
          </div>
        </TarpPayFirstIn>
      </IonContent>
    </IonPage>
  );
};

export default PhotoUpload;
